import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import MainHeader from "../../common/MainHeader";
import { FooterName, baseUrl, sendWhatsAppMessage } from "../../../Utility/constants";
import { useAsyncError, useNavigate } from "react-router-dom";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { FaList } from 'react-icons/fa';
import { SubjectCategoryMasterEndpoint } from "../../../Utility/Endpoints";
import useSchoolData from "../../../hooks/useSchoolData";

const StudentRegistration = () => {
  const {
    schoolInfo,
    schoolContactInfo,
    loading
  } = useSchoolData();
  const [schoolId, setSchoolId] = useState("");
  const [currentSession, setCurrentSession] = useState("");
  const [currentSessionId, setCurrentSessionId] = useState(0);
  const [schoolwebsite, setSchoolwebsite] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [schoolList, setSchoolList] = useState([]);
  const [greetingMessage, setGreetingMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [genderMaster, setGenderMaster] = useState([]);
  const [studentTypes, setStudentTypes] = useState([]);
  const [studentGroupTypes, setStudentGroupTypes] = useState([]);
  const [standards, setStandards] = useState([]);
  const [streams, setStreams] = useState([]);
  const [grantTypes, setGrantTypes] = useState([]);
  const [isRegistering, setIsRegistering] = useState(false);

  // Subject Selection 
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjectModalShow, setSubjectModalShow] = useState(false);
  const [selectedSubjectNames, setSelectedSubjectNames] = useState([]);
  const [errors, setErrors] = useState({});

  const studentTypeApiUrl = `${baseUrl}/api/CommonMaster/GetStudentTypeMasters`;
  const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;
  const studentGroupTypeApiUrl = `${baseUrl}/api/SubjectGroupMaster`;
  const [selectedStandardId, setSelectedStandardId] = useState("");
  const [standardValue, setStandardValue] = useState('');
  const [selectedStandardText, setSelectedStandardText] = useState("");
  const [categories, setCategories] = useState([]);

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    studentContactNumber: "",
    studentEmail: "",
    password: "",
    sessionId: 0,
    uIDNo: "",
    StudentTypeId: "",
    StudentGroupId: "",
    StandardId: "",
    StreamId: "",
    Subjects: "",
    GrantTypeID: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
     if (schoolId) {
    const fetchGrantTypes = async () => {
      try {
        const response = await axios.get(
           `${baseUrl}/api/CommonMaster/GetGrantTypeMastersBySchoolId/${schoolId}`
        );
        setGrantTypes(response.data);
      } catch (error) {
        console.error("Error fetching Grant Types", error);
      }
    };
    fetchGrantTypes();
  }
  },  [schoolId]);

  useEffect(() => {
    if (schoolId) {
      axios
        .get(`${standardApiUrl}?id=${schoolId}`)
        .then((response) => setStandards(response.data))
        .catch(() => console.log("Error fetching standards"));
    }
  }, [schoolId]);

  // Fetch gender details
  useEffect(() => {
    axios
      .get(`${baseUrl}/api/CommonMaster/GetGenderMasters`)
      .then((response) => {
        setGenderMaster(response.data);
      })
      .catch((error) => {
        console.log("Failed to load school details.");
      });

    axios
      .get(`${baseUrl}/api/StreamMaster`)
      .then((response) => setStreams(response.data))
      .catch(() => console.log("Error fetching stream details"));

    // Fetch student types
    axios
      .get(studentTypeApiUrl)
      .then((response) => setStudentTypes(response.data))
      .catch(() => console.log("Error fetching student types"));

    // Fetch student group types
    axios
      .get(studentGroupTypeApiUrl)
      .then((response) => setStudentGroupTypes(response.data))
      .catch(() => console.log("Error fetching student group types"));

    axios.get(SubjectCategoryMasterEndpoint)
      .then((response) => setCategories(response.data))
      .catch(() => console.log("Error fetching student group types"));
  }, []);

  const handleSubjectSelection = (subject) => {
    setSelectedSubjects((prev) => {
      // If already selected, remove it
      if (prev.includes(subject.subjectId)) return prev.filter(id => id !== subject.subjectId);

      // Count how many subjects are already selected in this category
      const categorySelectedCount = subjects
        .filter(s => s.subjectCategoryName === subject.subjectCategoryName)
        .filter(s => prev.includes(s.subjectId)).length;

      // Check maxLimit
      if (subject.subjectCategoryName !== "Compulsory" && categorySelectedCount >= subject.subjectMaxLimit) {
        toast.warning(`You can select maximum ${subject.subjectMaxLimit} subject(s) in ${subject.subjectCategoryName}`);
        return prev; // do not add
      }

      // Add subject
      return [...prev, subject.subjectId];
    });
  };

  const handleSaveSubjects = () => {

    const selectedSubjectIds = subjects
      .filter(subject => selectedSubjects.includes(subject.subjectId))
      .map(subject => subject.subjectId)
      .join(",");

    const selectedNames = subjects
      .filter(subject => selectedSubjects.includes(subject.subjectId))
      .map(subject => subject.subjectName)
      .join(", ");
    setSelectedSubjectNames(selectedNames);

    setFormData({
      ...formData,
      Subjects: selectedSubjectIds, // ✅ ONLY selected IDs
    });

    //setSelectedSubjects(selectedSubjects);
    setSubjectModalShow(false);
  };


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let isValid = true;
    // If the date is valid or if it's not the AdmissionDate field, proceed with updating the state
    if (isValid) {
      if (name === "StandardId") {
        setSelectedStandardId(value);
        setSelectedStandardText(e.target.options[e.target.selectedIndex].text);
        setStandardValue(e.target.options[e.target.selectedIndex].text);
      }

      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value
      }));
    }
  };

  const handleSubjectFetchAndShow = async () => {
    await loadSubjects(true);
    //setSubjectModalShow(true);
  };

  // Subject Selection 
  const loadSubjects = async (openSubjectsModal) => {
    // Validation
    if (Number(standardValue) > 10) {
      if (!(formData.StandardId && formData.StreamId && formData.StudentGroupId)) {
        toast.warning("Standard, stream and subject group type are required to fetch subjects.");
        return;
      }
    } else {
      if (!formData.StandardId) {
        toast.warning("Standard is required to fetch subjects.");
        return;
      }
    }

    try {
      const params = new URLSearchParams({
        classId: formData.StandardId,
        streamId: formData.StreamId || "",
        subjectGroup: formData.StudentGroupId || ""
      });

      const subjectUrl = `${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStream?${params}`;
      const response = await axios.get(subjectUrl);

      // Sort subjects by configured category order
      const sortedSubjects = categories.flatMap(category =>
        response.data
          .filter(subject => parseInt(subject.subjectCategoryId) === category.subjectCategoryID)
          .map(subject => ({
            ...subject,
            subjectCat: category.subjectCategoryName,
          }))
      );

      // Automatically select compulsory subjects
      const compulsoryIds = sortedSubjects
        .filter(s => s.subjectCategoryName === "Compulsory")
        .map(s => s.subjectId);

      setSelectedSubjects(prev => Array.from(new Set([...prev, ...compulsoryIds]))); // Merge with existing selections
      setSubjects(sortedSubjects);

      if (sortedSubjects.length > 0 && openSubjectsModal) {
        setSubjectModalShow(true);
      }
    } catch (error) {
      console.error("Error fetching subjects", error);
    }
  };


  // Fetch school details
  useEffect(() => {
    axios
      .get(`${baseUrl}/api/SchoolGeneralInfo`)
      .then((response) => {
        setSchoolList(response?.data?.slice(0, 1));
        setSchoolId(response?.data?.slice(0, 1)[0]?.schoolId);
        setSchoolwebsite(response?.data?.slice(0, 1)[0]?.websiteName);
        setSchoolName(response?.data?.slice(0, 1)[0]?.schoolOrCollegeName);
        if (response?.data?.length > 0 && response.data[0].currentSession) {
          setCurrentSession(response.data[0].currentSession);
          setCurrentSessionId(response.data[0].currentSessionId)
        } else {
          setCurrentSession("");
        }
      })
      .catch((error) => {
        toast.error("Failed to load school details.");
      });
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNumberChange = (e, maxLength) => {
    let value = e.target.value;

    if (/^\d*$/.test(value)) {
      if (value.length <= maxLength) {
        setFormData({ ...formData, [e.target.name]: value });
      }
    }
  };

  const getGreeting = () => {
    const hours = new Date().getHours();
    if (hours < 12) return "Good morning";
    if (hours < 17) return "Good afternoon";
    return "Good evening";
  };

  const school_Name = (id) => schoolList.find(x => x.schoolId == id).schoolOrCollegeName;

  // Handle form submit
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (isRegistering) return;  
  //   setIsRegistering(true);

  //   const postData = { ...formData, schoolId, sessionId: currentSessionId };
  //   try {
  //     axios
  //       .post(`${baseUrl}/api/PersonalDetails/NewRegistrationDetails`, postData)
  //       .then((response) => {

  //         if (!response || !response.data) {
  //           throw new Error("Invalid response");
  //         }

  //         const greeting = getGreeting();

  //         const message = `
  //     Dear <b>${formData.firstName} ${formData.middleName} ${formData.lastName}</b>, ${greeting}<br/><br/>
  //     Welcome! to <b>${schoolInfo.schoolOrCollegeName}!</b> Your registration is confirmed. 
  //     You can now access your account by logging in with your credentials. <br/><br/>
  //     If you have any questions or need further assistance, please feel free to contact our support team at 
  //     <b>support@panaceaschool.in</b> or click here to <a href="https://wa.me/message/MOB7252C62JAC1" target="_blank">WhatsApp</a> or call us at <b>9607081662</b>
  //     `;
  //         setGreetingMessage(message);
  //         setShowModal(true);

  //         const studentFullName = `${formData.firstName} ${formData.middleName} ${formData.lastName}`.trim();
  //         const phone = `91${formData.studentContactNumber}`;

  //         const whatsappUrl = `https://chatbotmarketing.in/api/v1/whatsapp/send/template?apiToken=11446%7CxR4BBpvQmkRyJXIW0dWSneCK6L2zzDWkIe7KPDMB3c98b270&phone_number_id=693821633824945&template_id=223786&templateVariable-studentname-1=${encodeURIComponent(studentFullName)}&templateVariable-schoolname-2=${school_Name(schoolId)}&templateVariable-websitename-3=${schoolwebsite}&templateVariable-aadharno-4=${formData.uIDNo}&templateVariable-password-5=${formData.password}&templateVariable-schoolname-6=${schoolName}&phone_number=${phone}`
  //         axios.get(whatsappUrl)
  //           .then((res) => {
  //             console.log("WhatsApp message sent successfully");
  //           })
  //           .catch((err) => {
  //             console.error("Failed to send WhatsApp message", err);
  //           });

  //         setFormData({
  //           firstName: "",
  //           middleName: "",
  //           lastName: "",
  //           gender: "",
  //           studentContactNumber: "",
  //           studentEmail: "",
  //           password: "",
  //           sessionId: 0
  //         });
  //       })
  //       .catch((error) => {
  //         if (error?.status === 400) {
  //           toast.error(error?.response?.data);
  //         }
  //         else {
  //           toast.error("Failed to register. Please try again.");
  //         }
  //       });
  //   } catch (error) {
  //     if (error?.status === 400) {
  //       toast.error(error?.response?.data);
  //     } else {
  //       toast.error("Failed to register. Please try again.");
  //     }
  //   } finally {
  //     setIsRegistering(false);
  //   }

  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prevent double click
    if (isRegistering) return;
    setIsRegistering(true);

    const postData = {
      ...formData,
      schoolId,
      sessionId: currentSessionId,
    };

    try {
      const response = await axios.post(
        `${baseUrl}/api/PersonalDetails/NewRegistrationDetails`,
        postData
      );

      if (!response || !response.data) {
        throw new Error("Invalid response");
      }

      const greeting = getGreeting();

      const message = `
      Dear <b>${formData.firstName} ${formData.middleName} ${formData.lastName}</b>, ${greeting}<br/><br/>
      Welcome! to <b>${schoolInfo.schoolOrCollegeName}!</b> Your registration is confirmed.
      You can now access your account by logging in with your credentials. <br/><br/>
      If you have any questions or need further assistance, please feel free to contact our support team at
      <b>support@panaceaschool.in</b> or click here to
      <a href="https://wa.me/message/MOB7252C62JAC1" target="_blank">WhatsApp</a>
      or call us at <b>9607081662</b>
    `;

      setGreetingMessage(message);
      setShowModal(true);

      // WhatsApp Message
      const studentFullName =
        `${formData.firstName} ${formData.middleName} ${formData.lastName}`.trim();
      const phone = `91${formData.studentContactNumber}`;

      const whatsappUrl = `https://chatbotmarketing.in/api/v1/whatsapp/send/template?apiToken=11446%7CxR4BBpvQmkRyJXIW0dWSneCK6L2zzDWkIe7KPDMB3c98b270&phone_number_id=693821633824945&template_id=223786&templateVariable-studentname-1=${encodeURIComponent(studentFullName)}&templateVariable-schoolname-2=${school_Name(schoolId)}&templateVariable-websitename-3=${schoolwebsite}&templateVariable-aadharno-4=${formData.uIDNo}&templateVariable-password-5=${formData.password}&templateVariable-schoolname-6=${schoolName}&phone_number=${phone}`;

      try {
        await axios.get(whatsappUrl);
        console.log("WhatsApp message sent successfully");
      } catch (err) {
        console.error("Failed to send WhatsApp message", err);
      }

      // Reset Form
      setFormData({
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        studentContactNumber: "",
        studentEmail: "",
        password: "",
        sessionId: 0,
        uIDNo: "",
        StudentTypeId: "",
        StudentGroupId: "",
        StandardId: "",
        StreamId: "",
        Subjects: "",
        GrantTypeID: "",
      });

      setSelectedSubjects([]);
      setSelectedSubjectNames("");

    } catch (error) {
      if (error?.response?.status === 400) {
        toast.error(error.response.data);
      } else {
        toast.error("Failed to register. Please try again.");
      }
    } finally {
      // Button becomes enabled only after API finishes
      setIsRegistering(false);
    }
  };


  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/");
  };

  return (
    <div>
      <MainHeader orgname={schoolList?.[0]?.schoolOrCollegeName} />
      <div className="container mt-3 mb-5">
        {(schoolInfo?.organizationName && schoolContactInfo?.city) &&
          <div className="text-center mb-3">
            <h4>Welcome to {schoolInfo?.organizationName} (Since {schoolInfo?.establishmentYear})</h4>
            <h2>
              {schoolInfo?.schoolOrCollegeName}, {schoolContactInfo?.city},
              Tal.{schoolContactInfo?.taluka}, Dist.{schoolContactInfo?.district}
              -{schoolContactInfo?.pincode}
            </h2>
          </div>
        }
        <div className="row justify-content-center">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <strong>Student Registration for the Academic Year - </strong>
                <span className="text-success fw-bold">{currentSession}</span></div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* School Dropdown */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="schoolId" className="form-label">
                        School Name
                      </label>
                      <select
                        id="schoolId"
                        name="schoolId"
                        className="form-select"
                        value={schoolId}
                        onChange={(e) => setSchoolId(e.target.value)}
                        required
                        disabled
                      >
                        {schoolList.map((school) => (
                          <option key={school.schoolId} value={school.schoolId}>
                            {school.schoolOrCollegeName}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* First Name */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="firstName" className="form-label">
                        First Name
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        className="form-control"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    {/* Middle Name */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="middleName" className="form-label">
                        Middle Name
                      </label>
                      <input
                        type="text"
                        id="middleName"
                        name="middleName"
                        className="form-control"
                        value={formData.middleName}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Last Name */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="lastName" className="form-label">
                        Last Name
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        className="form-control"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    {/* Gender */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="gender" className="form-label">
                        Gender
                      </label>
                      <select
                        id="gender"
                        name="gender"
                        className="form-select"
                        value={formData.gender}
                        onChange={handleChange}
                        required
                      >
                        <option value="">--Select Gender--</option>
                        {
                          genderMaster.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))
                        }
                      </select>
                    </div>

                    {/* Student Contact Number */}
                    <div className="col-md-6 mb-3">
                      <label htmlFor="studentContactNumber" className="form-label">
                        Contact Number
                      </label>
                      <input
                        type="text"
                        id="studentContactNumber"
                        name="studentContactNumber"
                        className="form-control"
                        value={formData.studentContactNumber}
                        onChange={(e) => handleNumberChange(e, 10)}
                        maxLength={10}
                        required
                        placeholder="Enter 10 digit mobile number"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Grant Type <span className="text-danger">*</span>
                      </label>

                      <select
                        className="form-select"
                        name="GrantTypeID"
                        value={formData.GrantTypeID || ""}
                        onChange={handleInputChange}
                      >
                        <option value="">Select Grant Type</option>

                        {grantTypes.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Student Type
                      </label>

                      <select
                        className="form-select"
                        name="StudentTypeId"
                        value={formData.StudentTypeId || ""}
                        onChange={handleInputChange}
                        disabled={standardValue && Number(standardValue) <= 10}
                      >
                        <option value="">Select Student Type</option>

                        {studentTypes.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                    </div>

                  </div>

                  <div className="row">

                    {/* Standard */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Standard <span className="text-danger">*</span>
                      </label>

                      <select
                        className="form-select"
                        name="StandardId"
                        value={formData.StandardId || ""}
                        onChange={handleInputChange}
                      >
                        <option value="">Select Standard</option>

                        {standards.map((standard) => (
                          <option key={standard.id} value={standard.id}>
                            {standard.standardName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Stream */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Stream
                        {standardValue && Number(standardValue) > 10 && (
                          <span className="text-danger"> *</span>
                        )}
                      </label>

                      <select
                        className="form-select"
                        name="StreamId"
                        value={formData.StreamId || ""}
                        onChange={handleInputChange}
                        disabled={standardValue && Number(standardValue) <= 10}
                      >
                        <option value="">Select Stream</option>

                        {streams.map((stream) => (
                          <option key={stream.id} value={stream.id}>
                            {stream.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Subject Group */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Subject Group
                      </label>

                      <select
                        className="form-select"
                        name="StudentGroupId"
                        value={formData.StudentGroupId || ""}
                        onChange={handleInputChange}
                      >
                        <option value="">Select Group Type</option>

                        {studentGroupTypes.map((type) => (
                          <option
                            key={type.subjectGroupId}
                            value={type.subjectGroupId}
                          >
                            {type.subjectGroupName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Stream */}


                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Subjects <span className="text-danger">*</span>

                        &nbsp;&nbsp;&nbsp;

                        <FaList
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            opacity: 0.5
                          }}
                          onClick={() => handleSubjectFetchAndShow(true)}
                        />

                        <span style={{ cursor: "pointer" }}>
                          &nbsp;Click here to add subject
                        </span>
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        name="Subjects"
                        value={selectedSubjectNames || ""}
                        onChange={handleInputChange}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row">

                    <div className="col-md-6 mb-3">
                      <label htmlFor="uIDNo" className="form-label">
                        Aadhaar Card No
                      </label>
                      <input
                        type="text"
                        id="uIDNo"
                        name="uIDNo"
                        className="form-control"
                        value={formData.uIDNo}
                        required
                        onChange={(e) => handleNumberChange(e, 12)}
                        maxLength={12}
                        placeholder="Enter 12 digit Aadhaar number"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <input
                        type="password"
                        id="password"
                        name="password"
                        className="form-control"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>


                  {/* Submit Button */}
                  {/* <button type="submit" className="btn btn-primary me-2">
                    Register
                  </button> */}
                  <button
                    type="submit"
                    className="btn btn-primary me-2"
                    disabled={isRegistering}
                  >
                    {isRegistering ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Registering...
                      </>
                    ) : (
                      "Register"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Bootstrap Modal */}
        {showModal && (
          <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="successModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="successModalLabel">
                    Registration Successful
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <p dangerouslySetInnerHTML={{ __html: greetingMessage }} />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className="modal-backdrop fade show"
          style={{ display: showModal ? "block" : "none" }}
        ></div>
      </div>

      <footer
        className="fixed-bottom"
        style={{
          backgroundColor: "black",
          color: "#6c757d",
          textAlign: "center",
          padding: "10px 0",
          boxShadow: "0 -1px 5px rgba(0, 0, 0, 0.1)",
          width: "100%",
        }}
      >
        <div className="container">
          <p className="mb-0" style={{ color: "white" }}>
            Copyright &copy; 2017-{new Date().getFullYear()} {FooterName} | All rights
            reserved.
          </p>
        </div>
      </footer>

      {/* Subject Selection Modal */}
      <Modal show={subjectModalShow} onHide={() => setSubjectModalShow(false)}
        dialogClassName="custom-modal-md">
        <Modal.Header closeButton>
          <Modal.Title>Choose Subjects</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {(() => {
              if (!subjects.length) return <p>No subjects available</p>;

              // Get unique category names from subjects
              const categoryNames = [...new Set(subjects.map(s => s.subjectCategoryName))];

              // Optional priority map for ordering
              const priority = { Compulsory: 1, Optional: 2, Language: 3 };
              const sortedCategories = categoryNames.sort((a, b) => {
                const pa = priority[a] ?? 99;
                const pb = priority[b] ?? 99;
                return pa - pb || a.localeCompare(b);
              });

              // Group subjects by category
              const groupedSubjects = sortedCategories.map(cat => {
                const group = subjects.filter(s => s.subjectCategoryName === cat);
                const { subjectCategoryConfigName, subjectMaxLimit } = group[0];
                return {
                  category: cat,
                  configName: subjectCategoryConfigName,
                  maxLimit: subjectMaxLimit,
                  items: group
                };
              });

              return groupedSubjects.map(group => (
                <div key={group.category} className="mb-4">
                  <h5 className="mb-3">
                    {group.category} - {group.configName} ({group.maxLimit === 0 ? 'All' : group.maxLimit})
                  </h5>
                  {Array.from({ length: Math.ceil(group.items.length / 3) }).map((_, rowIdx) => (
                    <Row key={rowIdx} className="mb-2">
                      {group.items
                        .slice(rowIdx * 3, rowIdx * 3 + 3)
                        .map(subject => (
                          <Col md={4} key={subject.subjectId}>
                            <Form.Check
                              type="checkbox"
                              label={subject.subjectName}
                              checked={selectedSubjects.includes(subject.subjectId)}
                              disabled={subject.subjectCategoryName === "Compulsory"}
                              onChange={() => handleSubjectSelection(subject)}
                            />
                          </Col>
                        ))}
                    </Row>
                  ))}
                </div>
              ));
            })()}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSaveSubjects}>Save Subjects</Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default StudentRegistration;
